// @spec AI-STR-026
// @spec AI-STR-029
'use client';

import { createFileRoute } from '@tanstack/react-router';

import { AIFeaturesCard, KnowledgeBaseSettingsCard } from '@/features/settings/ai';
import { useOrgRole } from '@/hooks/use-org-role';
import i18n from '@/lib/i18n';
import { useTranslation } from 'react-i18next';

export const Route = createFileRoute('/_authenticated/settings/ai-settings')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.aiSettings'),
  }),
  component: AISettingsPage,
});

/**
 * Organization AI settings page for managing AI features and knowledge bases.
 *
 * Allows organization admins to:
 * - Configure AI feature toggles and settings
 * - Set approval requirements for AI actions
 * - Customize AI response style
 * - Create and manage knowledge bases
 * - Upload documents for AI reference
 * - Monitor document processing status
 * - Trigger re-indexing of documents
 */
function AISettingsPage() {
  const { t } = useTranslation('settings');
  const { isAdmin } = useOrgRole();

  return (
    <div className="p-8">
      <div className="mx-auto max-w-4xl space-y-8">
        <header>
          <h1 className="text-3xl font-semibold text-foreground">{t('aiSettingsPage.title')}</h1>
          <p className="mt-1 text-muted-foreground">{t('aiSettingsPage.description')}</p>
        </header>

        <section className="space-y-6">
          <AIFeaturesCard isAdmin={isAdmin} />
          <KnowledgeBaseSettingsCard isAdmin={isAdmin} />
        </section>
      </div>
    </div>
  );
}
